import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Power Meter Icon Style 02 - Electric Meter (Material Symbol)
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:electric_meter
 */
export const Style02_ElectricMeter: React.FC<DeviceIconProps> = ({ 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = 'text-blue-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      electric_meter
    </span>
  );
};

export default Style02_ElectricMeter;
